import { hostsAtom } from "@sunrise/http-client";
import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { isEqual, isNil } from "lodash";

import { fetchEPGEntry } from "./epg.service";
import type { EPGEntryId } from "@sunrise/backend-types-core";

/**
 * Atom that fetches EPG details for a given EPG entry ID.
 */
export const epgDetailsForEpgEntryId = atomFamily(
  (param: { epgId: EPGEntryId }) => {
    const innerAtom = atom(async (get) => {
      const host = get(hostsAtom).data;
      if (isNil(host)) throw new Error("Host is not set");

      return fetchEPGEntry(host, param.epgId);
    });
    innerAtom.debugLabel = `epgDetailsForEpgEntryId(${param.epgId})`;
    return innerAtom;
  },
  isEqual,
);
